const R2_PUBLIC_BASE_URL = "https://media.hobbli.com";

const encodeObjectKey = (objectKey) =>
  String(objectKey)
    .split("/")
    .map((segment) => encodeURIComponent(segment))
    .join("/");

/**
 * Resolve an image record into a browser-displayable URL.
 *
 * Legacy Supabase images:
 *   use image_url
 *
 * R2 images:
 *   build the public URL from object_key
 */
export const resolveImageUrl = (image) => {
  if (!image) return null;

  if (image.storage_provider === "r2" && image.object_key) {
    return `${R2_PUBLIC_BASE_URL}/${encodeObjectKey(image.object_key)}`;
  }

  return image.image_url || null;
};